import { Box, Input, Typography } from '@oresundsbron/bridge-ui';
import { useForm, useFormParams } from '@oresundsbron/use-form';
import { BooleanValue } from '@oresundsbron/validators';
import Image from 'next/image';
import { FC } from 'react';
import { FormButton } from './Buttons';
import { FieldSet } from './Fieldset';

type Data = {
  subscribe: BooleanValue;
};

type Props = {
  title: string;
  description: string;
  labels: Record<keyof Data | 'loading', string>;
  helpText: string;
  hideNr?: true;
} & useFormParams<Data>;

export const ClubSubscribe: FC<Props> = ({
  namespace,
  title,
  description,
  labels,
  onValidate,
  helpText,
  hideNr,
}) => {
  const { stepNr, registerField, getError, validate, isActive, isValid } =
    useForm<Data>({
      namespace,
      title,
      onValidate,
    });

  return (
    <FieldSet id={namespace} title={title} nr={!hideNr ? stepNr : undefined}>
      <Box className="relative col-span-full mt-2">
        <Image
          className="col-span-full"
          src="/images/club.jpg"
          sizes="100vw"
          width={343}
          height={352}
          style={{
            width: '100%',
            height: 'auto',
            maxHeight: 352,
            aspectRatio: '16/9',
            objectFit: 'cover',
          }}
          alt="TODO"
        />
      </Box>
      <Typography className="col-span-full mt-2 max-w-[45ch]">
        {description}
      </Typography>
      <Input
        {...registerField('subscribe', { type: 'checkbox', value: 'true' })}
        className="col-span-full mt-2"
        label={labels.subscribe}
        error={getError('subscribe')}
        disabled={!isActive}
      />
      <Typography intent="label" size="sm" className="col-span-full">
        {helpText}
      </Typography>
      <FormButton
        loadingLabel={labels.loading}
        namespace={namespace}
        onClick={validate}
        disabled={!isActive || !isValid}
      />
    </FieldSet>
  );
};
